export const INITIAL_STATE = {
  count: 0,
  location: null,
  results: [],
  status: null,
  type: null
};

export const MESSAGES = {
  error: "Sorry, something went wrong, please try your search again",
  loading: "Searching for $type...",
  results: "We found $count that $match your search"
};

export const SEARCH_STATUS = {
  ERROR: "error",
  LOADING: "loading",
  SUCCESS: "success"
};

export const NIGHTS_OPTIONS = [
  { option: "", range: [1, 99], name: "Any length of stay" },
  { option: "1", range: [1, 1], name: "1 night" },
  { option: "2", range: [2, 2], name: "2 nights" },
  { option: "3-4", range: [3, 4], name: "3-4 nights" },
  { option: "5-7", range: [5, 7], name: "5-7 nights" },
  { option: "8+", range: [8, 99], name: "8+ nights" }
];

export const ROUNDS_OPTIONS = [
  { option: "", range: [-1, 99], name: "Any rounds" },
  { option: "1", range: [1, 1], name: "1 round" },
  { option: "2", range: [2, 2], name: "2 rounds" },
  { option: "3-4", range: [3, 4], name: "3-4 rounds" },
  { option: "5-14", range: [5, 14], name: "5-14 rounds" },
  { option: "unlimited", range: [-1, -1], name: "Unlimited rounds" }
];

export const SORT_OPTIONS = [
  {
    name: "Most popular first",
    option: "popularity"
  },
  {
    compare: results => results.sort((a, b) => a.package.price - b.package.price),
    name: "Lowest price first",
    option: "price-low"
  },
  {
    compare: results => results.sort((a, b) => b.package.price - a.package.price),
    name: "Highest price first",
    option: "price-high"
  }
];

export const URL_PARTS = {
  date: { length: 3, order: 2, re: /^(?:0\d|[12]\d|3[01])-(?:0\d|1[12])-202\d$/ },
  nights: { length: 1, order: 3, re: /^\d{1,2}(-\d{1,2}|\+)?$/ },
  place: { length: 2, order: 1 },
  rounds: { length: 1, order: 4, re: /^\d{1,2}(-\d{1,2})?|unlimited?$/ },
  sort: { length: 1, order: 5, re: /^popularity|price-(high|low)$/ }
};

export const VIEW_STATUS = {
  GRID: "grid",
  MAP: "map"
};



// WEBPACK FOOTER //
// ./const/SearchConsts.js